export default __webpack_public_path__ + "static/media/contactsYellow.d8c261aa.svg";